/**
 * Project-level constants for Nearmirer's own links.
 */
export const SITE_NAME = 'Nearmirer';
export const SITE_URL = 'https://nearmirer.com';
export const SUPPORT_EMAIL = 'hello@nearmirer.com';
export const REPO = 'https://github.com/nearmirer/nearmirer';

/** Build a link to a file in `docs/`, optionally to a heading anchor. */
export function docLink(file: string, anchor?: string): string {
  return `${REPO}/blob/main/docs/${file}${anchor ? `#${anchor}` : ''}`;
}
